import { h } from 'preact'

import { QUESTION_MARK_ICON_PATH } from 'apps-calculators/config'

interface InfoTooltipProps {
  text: string
}

const InfoTooltip = ({ text }: InfoTooltipProps) => (
  <span className="transfer-calculator__tooltip">
    <img
      src={QUESTION_MARK_ICON_PATH}
      className="transfer-calculator__tooltip-icon"
      alt="tip"
      loading="lazy"
      height="14"
      width="14"
      tabIndex={0}
    />
    <span
      className="transfer-calculator__tooltip-bubble"
      role="tooltip"
    >
      {text}
    </span>
  </span>
)

export default InfoTooltip
